"use client";
import { useState, useEffect } from "react";

const useMobile = (): { isMobile: boolean; hasLoaded: boolean } => {
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const [hasLoaded, setHasLoaded] = useState<boolean>(false);

    useEffect(() => {
        const checkIfMobile = () => {
            if (typeof window !== "undefined") {
                setIsMobile(window.innerWidth <= 768);
            }
        };

        checkIfMobile();
        setHasLoaded(true);

        window.addEventListener("resize", checkIfMobile);

        return () => {
            window.removeEventListener("resize", checkIfMobile);
        };
    }, []);

    return { isMobile, hasLoaded };
};

export default useMobile;